import React from 'react'
import { Badge } from 'react-bootstrap'
import { Download } from 'lucide-react'
import styled from 'styled-components'
import { StepComponentProps } from '../types'

const ComingSoonPlaceholder = styled.div`
  background: #2a2a2a;
  border-radius: 12px;
  padding: 3rem;
  text-align: center;
  border: 2px dashed #555;
  margin: 2rem 0;

  h3 {
    color: #fff;
    margin-bottom: 1rem;
  }

  p {
    color: #888;
    margin-bottom: 0;
  }
`

type GenerateStepProps = StepComponentProps

const GenerateStep: React.FC<GenerateStepProps> = ({ stepData, onNext, onBack }) => {
  // TODO: Implement generation configuration and execution
  // This could include:
  // - Image count selection
  // - Image size/resolution settings
  // - Output format selection
  // - Quality settings
  // - Generation progress tracking
  // - Download/export functionality

  return (
    <ComingSoonPlaceholder>
      <Download size={48} style={{ color: '#666', marginBottom: '1rem' }} />
      <h3>Generate Synthetic Data</h3>
      <p>
        Configure generation parameters and create your synthetic dataset with the selected objects,
        locations, and challenges.
      </p>
      <div className="mt-4">
        <p className="text-muted small">
          <strong>Future Features:</strong>
        </p>
        <ul className="text-muted small text-start" style={{ maxWidth: '400px', margin: '0 auto' }}>
          <li>Image count and batch size configuration</li>
          <li>Resolution and aspect ratio settings</li>
          <li>Output format selection (PNG, JPG, etc.)</li>
          <li>Quality and compression settings</li>
          <li>Annotation format selection (YOLO, COCO, etc.)</li>
          <li>Real-time generation progress tracking</li>
          <li>Batch download and export options</li>
        </ul>
      </div>
      <Badge bg="secondary" className="mt-3">
        Coming Soon
      </Badge>
    </ComingSoonPlaceholder>
  )
}

export default GenerateStep
